import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  token: null,
  routeId: "",
  isAuthenticated: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      // console.log("action.payload", action.payload);
      state.user = action.payload.user;
      state.routeId = action?.payload?.routeId;
      state.token = action.payload.token;
      state.isAuthenticated = true;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.routeId = "";
      state.isAuthenticated = false;
    },

    setUser: (state, { payload }) => {
      state.user = payload;
    },
  },
});

export const { login, logout } = authSlice.actions;

export default authSlice.reducer;
